import { Art } from "../ui/Art";
import { t } from "../lib/i18n";
import type { ReactNode } from "react";

/** Page title in the colourful style: pastel card, title and one line, a drawn picture on the right (a cover, or a mascot by default). */
export function PageHeader({ title, subtitle, art = "mascot/girl-wave" }: { title: string; subtitle: string; art?: string }) {
  const cover = art.startsWith("cover/");
  return (
    <div className="pastel-blue mb-6 grid items-center overflow-hidden rounded-[28px] sm:grid-cols-[1fr_auto]">
      <div className="p-5 sm:p-7">
        <h1 className="text-2xl font-black leading-tight text-slate-900 sm:text-4xl">{title}</h1>
        <p className="mt-1 text-sm text-slate-600 sm:text-base">{subtitle}</p>
      </div>
      <Art id={art} alt="" className={cover ? "h-40 w-full object-cover sm:h-44 sm:w-72" : "mx-auto h-32 w-32 sm:mr-6 sm:h-36 sm:w-36"} />
    </div>
  );
}

export function FeatureCard({ title, lines, children }: { title: string; lines: string[]; children?: ReactNode }) {
  return (
    <section className="rounded-card border border-surface-line bg-surface-muted p-4">
      <div className="mb-3 flex items-center gap-3">
        <span className="h-7 w-7 shrink-0 rounded-lg bg-accent" aria-hidden />
        <h2 className="font-semibold">{title}</h2>
      </div>
      <ul className="space-y-1 text-sm text-muted">
        {lines.map((l) => (
          <li key={l}>{l}</li>
        ))}
      </ul>
      {children}
    </section>
  );
}

export function CardGrid({ children }: { children: ReactNode }) {
  return <div className="grid grid-cols-1 gap-4 md:grid-cols-3">{children}</div>;
}

/** Honest placeholder for features whose phase is not built yet — never fake data. */
export function PhaseNotice({ phase }: { phase: number }) {
  return (
    <p role="status" className="mt-6 rounded-card border border-dashed border-surface-line p-4 text-sm text-muted">
      {t("Fungsi ini sedang dibina (Fasa {phase}). Tiada data dipaparkan sehingga ia disambungkan ke sistem sebenar.", { phase })}
    </p>
  );
}
